import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport201051Status: 'idle',
    startReport201051Error: undefined as any,
    loadUserParamsReport201051Status: 'idle',
    loadUserParamsReport201051Error: undefined as any,
    buchIni_IsProjektRueckstellungActiveStatus: 'idle',
    buchIni_IsProjektRueckstellungActiveError: undefined as any,
    buchIni_IntercompanyStatus: 'idle',
    buchIni_IntercompanyError: undefined as any,

    report201051List: [] as any[],
    buchIni_Intercompany: undefined as any,
    buchIni_IsProjektRueckstellungActive: undefined as any,
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport201051 = createAsyncThunk('report201051Slice/startReport201051', async ({ report201051 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport201051/`,
        prepareData(report201051),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport201051Status } = getState().report201051Slice
        return startReport201051Status !== 'pending'
    }
})

export const loadUserParamsReport201051 = createAsyncThunk('report201051Slice/loadUserParamsReport201051', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport201051/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport201051Status } = getState().report201051Slice
        return loadUserParamsReport201051Status !== 'pending'
    }
})

export const buchIni_IsProjektRueckstellungActive = createAsyncThunk('report201051Slice/buchIni_IsProjektRueckstellungActive', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_IsProjektRueckstellungActive/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { buchIni_IsProjektRueckstellungActiveStatus } = getState().report201051Slice
        return buchIni_IsProjektRueckstellungActiveStatus !== 'pending'
    }
})

export const buchIni_Intercompany = createAsyncThunk('report201051Slice/buchIni_Intercompany', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_Intercompany/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { buchIni_IntercompanyStatus } = getState().report201051Slice
        return buchIni_IntercompanyStatus !== 'pending'
    }
})

const Report201051Slice = createSlice({
    name: 'report201051Slice',
    initialState,
    reducers: {
        resetstartReport201051: (state) => {
            state.job = undefined
            state.startReport201051Error = undefined
        },
        resetstartReport201051Error: (state) => {
            state.startReport201051Error = undefined
        },
        resetloadUserParamsReport201051: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport201051Error = undefined
        },
        resetloadUserParamsReport201051Error: (state) => {
            state.loadUserParamsReport201051Error = undefined
        },
        resetbuchIni_IsProjektRueckstellungActive: (state) => {
            state.buchIni_IsProjektRueckstellungActive = undefined
            state.buchIni_IsProjektRueckstellungActiveError = undefined
        },
        resetbuchIni_IsProjektRueckstellungActiveError: (state) => {
            state.buchIni_IsProjektRueckstellungActiveError = undefined
        },
        resetbuchIni_Intercompany: (state) => {
            state.buchIni_Intercompany = undefined
            state.buchIni_IntercompanyError = undefined
        },
        resetbuchIni_IntercompanyError: (state) => {
            state.buchIni_IntercompanyError = undefined
        },
        removeFromReport201051ListById: (state, action) => {
            state.report201051List = state.report201051List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport201051ListByIds: (state, action) => {
            state.report201051List = state.report201051List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report201051List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport201051Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report201051List = []
            state.startReport201051Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport201051.pending, (state) => {
            state.startReport201051Status = 'pending'
            state.startReport201051Error = undefined
        })
        builder.addCase(startReport201051.fulfilled, (state, action) => {
            state.startReport201051Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport201051.rejected, (state, action) => {
            state.startReport201051Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport201051Error = action.error.message
            } else {
                state.startReport201051Error = action.payload
            }
        })

        builder.addCase(loadUserParamsReport201051.pending, (state) => {
            state.loadUserParamsReport201051Status = 'pending'
            state.loadUserParamsReport201051Error = undefined
        })
        builder.addCase(loadUserParamsReport201051.fulfilled, (state, action) => {
            state.loadUserParamsReport201051Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport201051.rejected, (state, action) => {
            state.loadUserParamsReport201051Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport201051Error = action.error.message
            } else {
                state.loadUserParamsReport201051Error = action.payload
            }
        })

        builder.addCase(buchIni_IsProjektRueckstellungActive.pending, (state) => {
            state.buchIni_IsProjektRueckstellungActiveStatus = 'pending'
            state.buchIni_IsProjektRueckstellungActiveError = undefined
        })
        builder.addCase(buchIni_IsProjektRueckstellungActive.fulfilled, (state, action) => {
            state.buchIni_IsProjektRueckstellungActiveStatus = 'idle'

            {
                state.buchIni_IsProjektRueckstellungActive = action.payload

            }
        })
        builder.addCase(buchIni_IsProjektRueckstellungActive.rejected, (state, action) => {
            state.buchIni_IsProjektRueckstellungActiveStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.buchIni_IsProjektRueckstellungActiveError = action.error.message
            } else {
                state.buchIni_IsProjektRueckstellungActiveError = action.payload
            }
        })

        builder.addCase(buchIni_Intercompany.pending, (state) => {
            state.buchIni_IntercompanyStatus = 'pending'
            state.buchIni_IntercompanyError = undefined
        })
        builder.addCase(buchIni_Intercompany.fulfilled, (state, action) => {
            state.buchIni_IntercompanyStatus = 'idle'

            {
                state.buchIni_Intercompany = action.payload

            }
        })
        builder.addCase(buchIni_Intercompany.rejected, (state, action) => {
            state.buchIni_IntercompanyStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.buchIni_IntercompanyError = action.error.message
            } else {
                state.buchIni_IntercompanyError = action.payload
            }
        })

    }
})

export const {
    resetstartReport201051,
    resetstartReport201051Error,
    resetloadUserParamsReport201051,
    resetloadUserParamsReport201051Error,
    resetbuchIni_IsProjektRueckstellungActive,
    resetbuchIni_IsProjektRueckstellungActiveError,
    resetbuchIni_Intercompany,
    resetbuchIni_IntercompanyError,
    removeFromReport201051ListById,
    removeFromReport201051ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report201051Slice.actions
export default Report201051Slice.reducer
